(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["minicart"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".js-minicart-product-recommendations");
    if (section) {
      getProductRecommendations(section);
    }
  });

  function getProductRecommendations(section) {
    const url = section.dataset.url;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          ".js-minicart-product-recommendations"
        );

        if (recommendations && recommendations.innerHTML.trim().length) {
          section.innerHTML = recommendations.innerHTML;
        }
      })
      .then(() => {
        initProductRecommendationsSwiper(section);
        initMinicartRecommendedProductsSelectors(section);
        section.classList.remove("hidden");
      })
      .catch((e) => {
        console.error(e);
      });
  }

  function initProductRecommendationsSwiper(section) {
    const ProductRecommendationsSwiper = section.querySelector(
      ".product-recommendations-swiper"
    );
    if (!ProductRecommendationsSwiper) return;
    window.Moonbase.initSwiper(ProductRecommendationsSwiper);
  }

  document.addEventListener("liquid-ajax-cart:request-end", function(event) {
    const {requestState, cart, previousCart, sections} = event.detail;
    const section = document.querySelector(".js-minicart-product-recommendations");

    if (requestState.requestType === 'add' && section) {
       getProductRecommendations(section);
    }
  });

 function initMinicartRecommendedProductsSelectors(section) {
    const slides = section.querySelectorAll('.swiper-slide');

    slides.forEach(slide => {
      const selects = slide.querySelectorAll('select');
      selects.forEach(select => {
        select.addEventListener('change', function() {
          const form = slide.querySelector('.minicart-recommended-products-form');
          const variantsJson = form.getAttribute('data-variants');
          const variants = JSON.parse(variantsJson);
          const selectedOptions = Array.from(selects).map(select => select.value);
          const variantIdInput = form.querySelector('[name="id"]');
          const matchingVariant = variants.find(variant => {
            return variant.options.every((opt, index) => opt === selectedOptions[index]);
          });

          if (matchingVariant) {
            variantIdInput.value = matchingVariant.id;
          }
        });
      });
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-recommendations"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".product-recommendations-section");
  if (section) {
    getProductRecommendations(section);
  }
});

function getProductRecommendations(section) {
  const url = section.dataset.url;
  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector(
        ".product-recommendations-section"
      );

      if (recommendations && recommendations.innerHTML.trim().length) {
        section.innerHTML = recommendations.innerHTML;
      }
    })
    .then(() => {
      initProductRecommendationsSwiper(section);
      section.classList.remove("hidden");
    })
    .catch((e) => {
      console.error(e);
    });
}

function initProductRecommendationsSwiper(section) {
  const ProductRecommendationsSwiper = section.querySelector(
    ".product-recommendations-swiper"
  );
  if (!ProductRecommendationsSwiper) return;
  window.Moonbase.initSwiper(ProductRecommendationsSwiper);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-recently-viewed"] && !window.DesignMode) return;
  try {
    
const localViewed = localStorage.recentlyViewedProduct;
function getRecentlyViewedProducts() {
  const productData = JSON.parse(localStorage.getItem("recentlyViewedProducts"));
  const fullContent = document.querySelector(".recently-viewed-grid");
  const recentlyViewedSection = document.querySelector(".recently-viewed-section");
  const productCardTemplate = document.querySelector("#product-card");
  const recentlyViewedHtml = [];
  const now = new Date();
  const nowTime = Math.floor(now.getTime() / 1000);

  // Get the last 8 products
  const latestViewedProducts = productData.slice(-9);

  productDataFiltered = latestViewedProducts?.filter(function(element) {
    return element.id !== window.Moonbase.productJson.id;
  });

  console.log(productDataFiltered?.length);
  if(productDataFiltered?.length > 2) {
    Promise.all(productDataFiltered.map(item => {
      return fetch(`/products/${item.handle}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productCard = doc.querySelector('#product-card');
          if (productCard) {
            const newSlide = document.createElement("div");
            newSlide.classList.add("swiper-slide", "!h-auto");
            newSlide.innerHTML = productCard.innerHTML;
            recentlyViewedHtml.push(newSlide);
          }
        })
        .catch(error => {
          console.error('Error fetching product card:', error);
        });
    }))
    .then(() => {
      fullContent.innerHTML = "";
      recentlyViewedHtml.forEach(item => {
        fullContent.appendChild(item);
      });
      const swiperEl = document.querySelector(".recently-viewed-swiper");
      if(!swiperEl) return;
      window.Moonbase.initSwiper(swiperEl);
    })
    .catch(error => {
      console.error('Error fetching product cards:', error);
    });
  }
  else {
    recentlyViewedSection.classList.add('!hidden');
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  getRecentlyViewedProducts();
});

  } catch(e) { console.error(e); }
})();
})();
